import { findSvelteComponentContainer } from './utils/render.js';

import { renderShapesMap } from './shapesMapOctober2024.js';

const mapElement = findSvelteComponentContainer('#map-october-2024');

async function main() {
  renderShapesMap(mapElement);
}

main().catch(console.error);
